import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const GOVERNING_BODY_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.governingBody,
    sortsOn: AssetColumns.governingBody,
    tooltip: CatalogReferenceDataSlugs.governing_body,
    label: "Governing Body",
    type: ColumnTypes.string,
    width: 410,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    cellValue: (item) => {
        if (item.isAsset) {
            return item.governing_body;
        }

        return null;
    },
};
